export default __webpack_public_path__ + "static/media/about-bg.f3cda5da.jpg";